import React, { useState } from "react";
import { Alert, Button, CircularProgress, TextField, Typography } from "@mui/material";
import {
  TIPOS_ROL,
  SUBTIPOS_COLABORADOR,
  TIPO_COLABORADOR,
  idrolDeSeleccion,
} from "../../domain/staff/roles";

const campoSx = {
  fontFamily: "Bricolage Grotesque",
  "& label.Mui-focused": { color: "#5656FF" },
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "#B2BAC2" },
    "&:hover fieldset": { borderColor: "#5656ff" },
    "&.Mui-focused fieldset": { borderColor: "#5656ff" },
  },
};

const tarjetaStyle = (activa) => ({
  display: "block",
  width: "100%",
  height: "100%",
  textAlign: "left",
  border: activa ? "1px solid #5656ff" : "1px solid #ccc",
  borderRadius: "8px",
  padding: "14px 16px",
  background: activa ? "#e6e6ff" : "#fff",
  cursor: "pointer",
});

/* Tarjeta seleccionable para un rol o un tipo de colaborador. */
const Opcion = ({ activa, titulo, descripcion, onClick }) => (
  <button type="button" onClick={onClick} style={tarjetaStyle(activa)} aria-pressed={activa}>
    <div style={{ fontWeight: "bold", color: "#0b0060" }}>{titulo}</div>
    <div style={{ fontSize: "13px", color: "#555" }}>{descripcion}</div>
  </button>
);

/* Alta de un miembro del staff: mail, rol (con su subtipo si es colaborador)
 * y observación. `onAgregar` recibe los datos y devuelve {ok, error}. */
const FormularioMiembro = ({ onAgregar, deshabilitado = false }) => {
  const [email, setEmail] = useState("");
  const [tipo, setTipo] = useState("");
  const [subtipo, setSubtipo] = useState(null);
  const [observacion, setObservacion] = useState("");
  const [error, setError] = useState("");
  const [enviando, setEnviando] = useState(false);

  const idrol = idrolDeSeleccion(tipo, subtipo);
  const completo = Boolean(email.trim() && idrol);

  const elegirTipo = (valor) => {
    setTipo(valor);
    if (valor !== TIPO_COLABORADOR) setSubtipo(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setEnviando(true);
    const resultado = await onAgregar({ email, idrol, tipo, observacion });
    setEnviando(false);

    if (!resultado.ok) {
      setError(resultado.error);
      return;
    }
    setEmail("");
    setTipo("");
    setSubtipo(null);
    setObservacion("");
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      <TextField
        sx={{ ...campoSx, mb: 1 }}
        type="email"
        label="Correo electrónico"
        placeholder="johndoe@gmail.com"
        fullWidth
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <Typography sx={{ fontSize: "18px", fontWeight: 500, mt: 2, mb: 2 }}>
        Seleccioná un rol para el miembro
      </Typography>
      <div className="row">
        {TIPOS_ROL.map((rol) => (
          <div key={rol.value} className="col-sm-6 col-md-4 mb-3">
            <Opcion
              activa={tipo === rol.value}
              titulo={rol.label}
              descripcion={rol.description}
              onClick={() => elegirTipo(rol.value)}
            />
          </div>
        ))}
      </div>

      {tipo === TIPO_COLABORADOR && (
        <>
          <Typography sx={{ fontSize: "16px", fontWeight: 500, mt: 1, mb: 2 }}>
            Seleccioná el tipo de colaborador
          </Typography>
          <div className="row">
            {SUBTIPOS_COLABORADOR.map((sub) => (
              <div key={sub.idrol} className="col-sm-6 col-md-3 mb-3">
                <Opcion
                  activa={subtipo === sub.idrol}
                  titulo={sub.label}
                  descripcion={sub.description}
                  onClick={() => setSubtipo(sub.idrol)}
                />
              </div>
            ))}
          </div>
        </>
      )}

      <TextField
        sx={{ ...campoSx, mt: 1 }}
        label="Observación (opcional)"
        helperText="Ej: PUERTA1."
        fullWidth
        margin="normal"
        value={observacion}
        onChange={(e) => setObservacion(e.target.value)}
      />

      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}

      <div className="d-flex justify-content-end mt-3">
        <Button
          type="submit"
          variant="contained"
          disabled={deshabilitado || enviando || !completo}
          sx={{ backgroundColor: "#5656FF", "&:hover": { backgroundColor: "#4545ee" } }}
        >
          {enviando && <CircularProgress size={18} sx={{ mr: 1, color: "white" }} />}
          {enviando ? "Verificando el correo..." : "Agregar miembro"}
        </Button>
      </div>
    </form>
  );
};

export default FormularioMiembro;
